module.exports = __webpack_public_path__ + "static/media/earn-money.2e751c13.png";